import React from 'react'
import GptSearchBar from './GptSearchBar'
import GptMovieSuggestions from './GptMovieSuggestions'

const GptSearch = () => {
  return (
    <div className=''>
    
      <GptSearchBar/>
    
    
       
    </div>
  )
}

export default GptSearch